import React from 'react';
// TCM Color Palette and shared style constants
export const C = {
  crimson: '#8B1A1A',
  crimsonMid: '#B22222',
  crimsonBorder: '#D4A5A5',
  crimsonPale: '#FCF2F2',
  crimsonHover: '#F5E0E0',
  gold: '#C9A84C',
  goldLight: '#E8D5A3',
  goldPale: '#FBF6E9',
  goldBorder: '#D4BF7A',
  goldDark: '#8B6C14',
  ink: '#1a0800',
  inkMid: '#3d1a00',
  parchment: '#FAF0DC',
  parchmentMid: '#F5E8C8',
  parchmentDark: '#E8D5A3',
  waGreen: '#25D366',
  waDark: '#128C7E',
  tgBlue: '#229ED9',
  tgDark: '#1A7BBD'
};
export const inputStyle: React.CSSProperties = {
  width: '100%',
  padding: '9px 12px',
  border: `1px solid ${C.parchmentDark}`,
  borderRadius: 8,
  background: C.parchment,
  fontSize: 13,
  color: C.ink,
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border 0.15s',
  boxSizing: 'border-box'
};
export const labelStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 700,
  color: C.inkMid,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  marginBottom: 4,
  display: 'block'
};
export const cardStyle: React.CSSProperties = {
  background: '#fff',
  border: `1px solid ${C.parchmentDark}`,
  borderTop: `3px solid ${C.crimsonMid}`,
  borderRadius: 12,
  boxShadow: `0 2px 12px rgba(139,26,26,0.08)`,
  overflow: 'hidden',
  marginBottom: 16
};
export const cardHeaderStyle: React.CSSProperties = {
  padding: '16px 20px 0',
  background: C.crimsonPale
};
export const cardBodyStyle: React.CSSProperties = {
  padding: 20
};